import { PackageTypeList } from "@/resources/packages/PackageTypeList";

/**
 * Principles — packages of `package_type='principle'` over the unified
 * `/api/packages`.
 */
export function PrincipleList() {
  return (
    <PackageTypeList
      resource="principles"
      packageType="principle"
      title="Principles"
      description="Governing principles that constrain frames, contours, and skills."
      emptyMessage="No principles yet."
    />
  );
}

export default PrincipleList;
